import React from "react";
import { getSEOData } from "../../../global/utils/constants/seoConfig";
import SEO from "../../../global/components/SEO/SEO";
import ContactUsBanner from "../Components/ContactUsBanner";
import ContactWrapper from "../Components/ContactWrapper";

const ContactUs = () => {
  const seoData = getSEOData("/contact-us");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <ContactUsBanner />
      <ContactWrapper />
    </>
  );
};

export default ContactUs;